import React, { Component } from 'react'
import { Row } from 'antd'
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
} from 'react-share';

export default class Share extends Component {
  state = {};

  render() {
    const url = 'https://medor.coop/nos-series/la-douleur-des-belges/opioides-datavisualisations/'
    return (
      <Row type="flex" gutter={16} style={{ marginTop: 16 }}>
        <TwitterShareButton url={url} style={{ cursor: 'pointer' }} title="Contramal, Durogesic, Oxycontin, ça vous dit quelque chose? Nous sommes plus d’un million en Belgique à avoir pris un de ces puissants #opioïdes en 2018. Carto de la Belgique qui souffre par @Medor_mag et @jetpackAI Vous allez connaître votre douleur.">
          <TwitterIcon size={48} round={true} />
        </TwitterShareButton>
        <LinkedinShareButton url={url} style={{ cursor: 'pointer' }} quote="Contramal, Durogesic, Oxycontin, ça vous dit quelque chose? Nous sommes plus d’un million en Belgique à avoir pris, au moins une fois, un de ces puissants anti-douleurs opioïdes en 2018. Carto de la Belgique qui souffre par Médor et Jetpack.AI (www.medor.coop & www.jetpack.ai). Vous allez connaître votre douleur.">
          <LinkedinIcon size={48} round={true} />
        </LinkedinShareButton>
        <FacebookShareButton url={url} style={{ cursor: 'pointer' }} quote="Contramal, Durogesic, Oxycontin, ça vous dit quelque chose? Nous sommes plus d’un million en Belgique à avoir pris, au moins une fois, un de ces puissants anti-douleurs opioïdes en 2018. Carto de la Belgique qui souffre par Médor et Jetpack.AI (www.medor.coop & www.jetpack.ai). Vous allez connaître votre douleur."> 
          <FacebookIcon size={48} round={true} />
        </FacebookShareButton>
      </Row>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Share/Share.js